import { Tooltip } from 'antd';
import { FileSearchOutlined, BarChartOutlined, VerticalAlignMiddleOutlined, SettingOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import styles from './WorkspaceNav.module.scss';
import InteractiveChatIcon from '../icons/InteractiveChatIcon';
import { useUserProfile } from '../../context/UserProfileContext';

type WorkspaceNavKey = 'chat' | /* 'upload' | */ 'policy' | 'analysis' | 'configComparison' | 'settings';

interface NavItem {
  key: WorkspaceNavKey;
  label: string;
  icon: ReactNode;
}

interface Props {
  active: WorkspaceNavKey;
  onChange: (key: WorkspaceNavKey) => void;
}

const items: NavItem[] = [
  { key: 'chat', label: 'Chat', icon: <InteractiveChatIcon /> },
  // { key: 'upload', label: 'Upload', icon: <CloudUploadOutlined /> },
  { key: 'policy', label: 'Policy Extraction', icon: <FileSearchOutlined /> },
  { key: 'analysis', label: 'Policy Analysis', icon: <BarChartOutlined /> },
  { key: 'configComparison', label: 'Configuration Comparison', icon: <VerticalAlignMiddleOutlined className={styles.rotate90} /> },
];

const WorkspaceNav = ({ active, onChange }: Props) => {
  const { profile } = useUserProfile();
  const isAdmin = profile?.isAdmin ?? false;

  return (
    <nav className={styles.nav}>
      <div className={styles.logo}>AI</div>
      <div className={styles.items}>
        {items.map((it) => {
          const activeItem = it.key === active;
          return (
            <Tooltip key={it.key} title={it.label} placement="right">
              <button
                className={activeItem ? styles.itemActive : styles.item}
                onClick={() => onChange(it.key)}
                aria-label={it.label}>
                {it.key === 'chat' ? <InteractiveChatIcon active={activeItem} /> : it.icon}
              </button>
            </Tooltip>
          );
        })}
      </div>
      <div className={styles.spacer} />
      {isAdmin && (
        <div className={styles.items}>
          <Tooltip title="Settings" placement="right">
            <button
              className={active === 'settings' ? styles.itemActive : styles.item}
              onClick={() => onChange('settings')}
              aria-label="Settings"
              data-testid="settings-nav"
            >
              <SettingOutlined />
            </button>
          </Tooltip>
        </div>
      )}
    </nav>
  );
};
export default WorkspaceNav;
